$(document).ready(function() {
    // Helper to find focusable elements for Focus Trapping
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function openModal(trigger) {
        const modalId = $(trigger).data("modal");
        const $modal = $(modalId);
        
        if ($modal.length) {
            $modal.addClass("show").attr('aria-hidden', 'false');
            $(trigger).attr("aria-expanded", "true");
            
            // Focus Management: Move focus to the first element in the modal
            const $firstFocusable = $modal.find(focusableElements).filter(':visible').first();
            $firstFocusable.focus();
        }
    }

    function closeModal($modal) {
        if ($modal.hasClass("show")) {
            $modal.removeClass("show").attr('aria-hidden', 'true');
            
            // Return focus to the specific button that opened THIS modal
            const modalId = "#" + $modal.attr("id");
            $(`.btn-open-modal[data-modal="${modalId}"]`).attr("aria-expanded", "false").focus();
        }
    }

    // 1. Handle Open: Click and Keyboard (Enter/Space)
    $(document).on("click keydown", ".btn-open-modal", function(e) {
        if (e.type === "keydown") {
            if (e.key !== "Enter" && e.key !== " ") return;
            e.preventDefault(); 
        }
        openModal(this);
    });

    // 2. Close modal: Close button
    $(document).on("click", ".modal-close", function() {
        closeModal($(this).closest(".modal-custom"));
    });

    // 3. Close modal: Click outside (overlay)
    $(document).on("click", ".modal-custom", function(e) {
        if ($(e.target).is(".modal-custom")) {
            closeModal($(this));
        }
    });

    // 4. Close modal: ESC key
    $(document).on("keydown", function(e) {
        if (e.key === "Escape") {
            closeModal($(".modal-custom.show"));
        }
    });
});




